import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, Select, Spinner } from "@chakra-ui/react";
import { unwrapFetchResponse } from "./utils/unwrapApiResponse";

const DocumentDefinitionSelectById = ({
  label = "Select Document Definition",
  selectedDocumentDefinitionId,
  onChange,
  definitionType,
  templateType,
  size = "md",
  height = undefined,
}) => {
  const [documentDefinitions, setDocumentDefinitions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocumentDefinitions = async () => {
      setLoading(true);
      try {
        const url = new URL("https://documents.poc.mrc.ai/api/definitions");
        if (definitionType) {
          url.searchParams.set("type", definitionType);
        }
        if (templateType) {
          url.searchParams.set("templateType", templateType);
        }

        const res = await fetch(url.toString());
        const json = await unwrapFetchResponse(res);

        if (Array.isArray(json)) {
          const sorted = [...json].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "")
          );
          setDocumentDefinitions(sorted);
        } else {
          setDocumentDefinitions([]);
        }
      } catch (err) {
        console.error("Failed to fetch document definitions:", err);
        setDocumentDefinitions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDocumentDefinitions();
  }, [definitionType, templateType]);

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      {loading ? (
        <Spinner />
      ) : (
        <Select
          placeholder="Select document definition..."
          value={selectedDocumentDefinitionId || ""}
          onChange={(e) => {
            onChange(e.target.value || null); // Send just the ID
          }}
          size={size}
          height={height}>
          {documentDefinitions.map((definition) => (
            <option key={definition._id} value={definition._id}>
              {definition.name}
            </option>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default DocumentDefinitionSelectById;
